import { useContext, useMemo } from "react";
import { AppContext } from "@/contexts/appContexts";

const flattenCategories = (categories = []) => {
  const result = [];

  const traverse = (nodes) => {
    for (const node of nodes) {
      result.push(node);
      if (Array.isArray(node?.children_data)) {
        traverse(node?.children_data);
      }
    }
  };

  traverse(categories);
  return result;
};

export const useExcludeFilters = ({ filters = [], categoryId }) => {
  const { categoryData } = useContext(AppContext);

  return useMemo(() => {
    if (!filters?.length || !categoryData?.children_data || !categoryId)
      return [];

    const flatCategories = flattenCategories(categoryData?.children_data);

    const matchedCategory = flatCategories?.find(
      (cat) => String(cat?.id) === String(categoryId)
    );

    const excludeAttributes =
      matchedCategory?.exclude_product_attribute
        ?.split(",")
        ?.map((attr) => attr?.trim())
        ?.filter(Boolean) || [];

    return filters?.filter(
      (facet) => !excludeAttributes?.includes(facet?.code)
    );
  }, [filters, categoryData?.children_data, categoryId]);
};
